export function isUSPhoneNumber(str?: string): boolean {
  if (!str) {
    return false;
  }

  // eslint-disable-next-line no-useless-escape
  return /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(str);
}

export const USPhoneMaskRegex = /\([2-9]\d{2}\) \d{3}-\d{4}/;
export const tenDigit = /\d{10}/;

export function cleanPhone(num: string | number): string {
  if (!num) {
    return '';
  }
  const str = String(num);
  const numbers = str.replace(/[^0-9]/g, '');
  return numbers.indexOf('1') === 0 ? numbers.substring(1) : numbers;
}

export function getUSPhoneNumber(phoneNumberString: string) {
  const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return null;
}

export const phoneNumberMask = [
  '(',
  /[2-9]/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/
];
